import theme from '../../base';

const couponBox = {
  background: theme.colors.neutrals.gray200,
  foreground: theme.colors.greens.green700,
  border: theme.colors.greens.green500,
  messageForeground: theme.colors.neutrals.gray500,
};

export default couponBox;
